import {useState} from "react";

import "./index.scss";

const initialsOf = (firstName, lastName, name) => {
	const parts =
		firstName || lastName
			? [firstName, lastName]
			: String(name || "").split(" ");
	return (
		parts
			.filter(Boolean)
			.slice(0, 2)
			.map((p) => p.trim().charAt(0))
			.join("")
			.toUpperCase() || "?"
	);
};

// Tondo con foto o iniziali. size: small 32 | medium 44 | large 60.
// status (good | warning | critical) è un pallino che va sempre con statusLabel.
export default function PlayerAvatar({
	firstName,
	lastName,
	name,
	imageUrl,
	size = "medium",
	status,
	statusLabel,
}) {
	const [broken, setBroken] = useState(false);
	const showPhoto = imageUrl && !broken;

	return (
		<span className={"player-avatar player-avatar--" + size}>
			{showPhoto ? (
				<img
					className="player-avatar__photo"
					src={imageUrl}
					alt=""
					onError={() => setBroken(true)}
				/>
			) : (
				<span className="player-avatar__initials" aria-hidden="true">
					{initialsOf(firstName, lastName, name)}
				</span>
			)}
			{status && (
				<span
					className={"player-avatar__status player-avatar__status--" + status}
					role="img"
					aria-label={statusLabel}
					title={statusLabel}
				/>
			)}
		</span>
	);
}
